import { type PropsWithChildren } from "react";
import { ModuleApiAccessBoundary } from "../workspace/ModuleApiAccessBoundary.tsx";
import { ModuleWorkspaceBoundary } from "../workspace/ModuleWorkspaceBoundary.tsx";

/**
 * Above the page layout: only what needs no data and never renders <Navigate>. Providers that fetch and gates go
 * inside the layout, or the header and sidebar flicker. See .claude/rules/providers-and-gates.md.
 */
export function ModuleAuthenticatedProviders({ children }: PropsWithChildren) {
    return (
        <ModuleWorkspaceBoundary>
            <ModuleApiAccessBoundary>{children}</ModuleApiAccessBoundary>
        </ModuleWorkspaceBoundary>
    );
}
